module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "0em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "0.82em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [_c('div', [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    key: _vm.formComponentKey,
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("send, share and sell")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', [_c('h3', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "email",
      "type": "text",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "change": function($event) {
        _vm.validateEmail(_vm.user.email)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.email) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.email && _vm.action_verified.email) && (!_vm.error_messages.email)) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.email) ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.email) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.email))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "phone",
      "type": "number",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "change": function($event) {
        _vm.validatePhone(_vm.user.phone)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.phone) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.phone && _vm.action_verified.phone) && (!_vm.error_messages.phone)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.phone) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.phone) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.phone))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(4)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                  "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(6)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v("kk" + _vm._s(_vm.error_messages) + "---set_user_loggedIn--" + _vm._s(_vm.set_user_loggedIn) + "\r\n                        "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), (((!_vm.error_messages.email) && (!_vm.error_messages.phone))) ? _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProfile(2)
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Create your acoount "), _c('br'), _vm._v(" to set up orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a16144"}!./src/pages/CreateAccount/template.html
// module id = 507
// module chunks = 0